export default "__VITE_ASSET__DkNyEaME__"